import { render } from "./Company.vue?vue&type=template&id=6bd9cbf2&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6bd9cbf2"

export default script